import { render, staticRenderFns } from "./SleepManualContent.vue?vue&type=template&id=b05ea6c8"
import script from "./SleepManualContent.vue?vue&type=script&lang=js"
export * from "./SleepManualContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports